// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import * as Slice from "../slices/timeline"
import * as Actions from "../actions"
import { showSnackBar } from "../../snackbar/actions"
import { from, Init, timesheetFieldService } from "../../../app/rpc"
import {
  AddFavouriteTimesheetFieldOptionRequestSchema,
  ListFavouriteTimesheetFieldOptionsResponse,
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

type AddFavouriteTimesheetFieldOptionRpc = (request: Init<typeof AddFavouriteTimesheetFieldOptionRequestSchema>) => Observable<ListFavouriteTimesheetFieldOptionsResponse>

export const addFavouriteTimesheetFieldOption = (addFavouriteTimesheetFieldOptionRpc: AddFavouriteTimesheetFieldOptionRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.addFavouriteTimesheetFieldOption.match),
      mergeMap((action) => addFavouriteTimesheetFieldOptionRpc(action.payload)
        .pipe(
          map(response => ({
            siteId: action.payload.siteId ?? "",
            options: response.timesheetFieldOptions,
          })),
          map(Slice.setFavouriteTimesheetFieldOptions),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_add_favourite_timesheet_field_option_failed",
              message: "Failed to favourite timesheet field option. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const addFavouriteTimesheetFieldOptionRpc = (request: Init<typeof AddFavouriteTimesheetFieldOptionRequestSchema>): Observable<ListFavouriteTimesheetFieldOptionsResponse> =>
  from(() => timesheetFieldService.addFavouriteTimesheetFieldOption(create(AddFavouriteTimesheetFieldOptionRequestSchema, request)))

export default addFavouriteTimesheetFieldOption(addFavouriteTimesheetFieldOptionRpc)
